<template>
<div>
  <h-section-header back="/dashboard"> {{client.first_name}}'s reflections </h-section-header>
  <word-cloud :end-point="WORD_CLOUD_END_POINT" @wordClick="searchFor"/>
  <div class="section-header">
    <div class="search">
      <input placeholder="Search" type="text" v-model="search" @keydown="startSearch"/>
      <button v-if="search" @click="reset"><i class="material-icons">close</i></button>
    </div>
    <button v-if="limit" @click="displayAllReflections(undefined)">Display All</button>
    <button v-else @click="displayAllReflections(4)">Hide All</button>
  </div>
  <div
      v-infinite-scroll="more"
      infinite-scroll-disabled="busy"
      infinite-scroll-distance="15"
      class="row card-rows client-reflections"
      >
      <div class="card card--transparent reflection" v-for="reflection in reflections" :key="reflection.id">
        <div class="card--container">
          <div class="date">{{reflection.createdAt}}</div>
          <div>{{reflection.reflection}}</div>
        </div>
      </div>
    </div>
  <div v-if="loading">Loading</div>
</div>
</template>

<script>
import wordCloud from "@/components/wordCloud";
import Paginator from "@/services/api/paginator";
import moment from "moment";
export default {
  props: ["client"],
  components: { wordCloud },
  data() {
    return {
      search: "",
      loading: false,
      reflections: [],
      limit: 4,
      WORD_CLOUD_END_POINT: `${ process.env.VUE_APP_API_URL }coaches/client-pulse-surveys/word_cloud/?user=${this.$route.params.id}`, 
    }
  },
  created() {
    this.paginator = new Paginator("CoachClientPulseSurveys", {user: this.client.id, limit: this.limit});
  },
  methods: {
    displayAllReflections(length) {
      this.limit = length;
      this.searchFor(this.search);
    },
    startSearch() {
      clearTimeout(this.timeout);
      this.reflections = [];
      this.timeout = setTimeout(() => {
        this.searchFor(this.search);
      }, 500);
    },
    reset() {
      this.paginator = new Paginator("CoachClientPulseSurveys", {user: this.client.id, limit: this.limit});
      this.reflections = [];
      this.search = "";
      clearTimeout(this.timeout);
      this.more();
    },
    searchFor(word) {
      this.search = word;
      this.paginator = new Paginator("CoachClientPulseSurveys", {user: this.client.id, search: word, limit: this.limit})
      this.reflections = [];
      this.more();
    },
    more() {
      if (this.loading || this.paginator.finished || this.error || (this.limit && this.reflections.length > 0)) {
        return;
      }
      this.busy = true;
      this.loading = true;
      return this.paginator
        .next()
        .then(reflections => {
          reflections.forEach(r => {
            r.createdAt = moment(r.created_at).format("L");
          });
          this.reflections = [...this.reflections, ...reflections];
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.busy = false;
          this.loading = false;
        });
    }
  }
}
</script>

<style lang="less" scoped>
.client-reflections {
  flex-wrap: wrap;
  .reflection {
    margin-top: 15px;
    position: relative;
    .date {
      position: absolute;
      top: 5px;
      right: 12px;
      font-size: 12px;
    }
  }
}

.search {
  display: flex;
  flex-direction: row;
  position: relative;
  input {
    margin-top: 0px;
  }
  button {
    position: relative;
    display: flex;
    align-content: center;
    position: absolute;
    right: 5px;
    top: 3px;
    color: black;
  }
}
</style>
